import Floor from './component';

export default Floor;
